import React from "react";
import cx from "classnames";

import "./PageLayout.sass";
import { Scrollbar } from "@smartsuite/react-ui/lib";
import { useDisplayMode } from "../../hooks/useDisplayMode";

export interface PageLayoutProps {
  children: React.ReactNode;
}

export const PageLayout: React.FC<PageLayoutProps> = ({ children }) => {
  const { isPopup } = useDisplayMode();

  return (
    <div className={cx("page-layout", { "page-layout--popup": isPopup })}>
      <Scrollbar
        classes="page-layout__scrollbar"
        contentProps={{ className: "page-layout__content" }}
        gutterRight={2}
        gutterTop={2}
        gutterBottom={2}
      >
        <div className="page-layout__wrapper">{children}</div>
      </Scrollbar>
    </div>
  );
};
